<template>
  <div>
    <!-- 面包屑 -->
    <bread-crumb path='内容管理' subPath='今日灵修列表'></bread-crumb>
    <!-- 主体列表 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="25">
          <el-button type="primary" @click="showAddDialog">添加今日灵修</el-button>&nbsp;
          <el-select v-model="param.group_id" placeholder="请选择栏目" filterable @change="getCategoryList">
            <el-option label="请选择栏目" :value="0"></el-option>
            <el-option v-for="item in groupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>&nbsp;
          <el-select v-model="param.speaker_id" placeholder="请选择讲员" filterable @change="getCategoryList">
            <el-option label="请选择讲员" :value="0"></el-option>
            <el-option v-for="item in speakerList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>&nbsp;
          <el-select v-model="param.category_id" placeholder="请选择专辑名称" filterable @change="getList">
            <el-option label="请选择专辑" :value="0"></el-option>
            <el-option v-for="item in categoryList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>&nbsp;
          <el-select v-model="param.cycle" placeholder="请选择循环类型" filterable @change="getList">
            <el-option label="请选择循环类型" :value="0"></el-option>
            <el-option v-for="item in cycleList" :key="item.id" :label="item.title" :value="item.id"></el-option>
          </el-select>&nbsp;
          <el-date-picker
            v-model="dateValue"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="发布开始日期"
            end-placeholder="发布结束日期"
            value-format="timestamp"
            @change="timeChange"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-col>
      </el-row>
    </el-card>
    <el-table :data="practiceDayList" stripe border :cell-style="{ textAlign: 'center' }">
      <el-table-column prop="id" label="ID" align="center" width="70px"></el-table-column>
      <el-table-column label="日期" align="center">
        <template slot-scope="scope">
          {{scope.row.day_time*1000 | dateFormat}}
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" align="center"></el-table-column>
      <el-table-column prop="pic" label="图标" align="center">
        <template slot-scope="scope">
          <el-image :src="scope.row.pic+'?imageView2/0/w/50'" class="list_img"></el-image>
        </template>
      </el-table-column>
      <el-table-column prop="group_name" label="栏目" align="center"></el-table-column>
      <el-table-column label="循环" align="center">
        <template slot-scope="scope">
          {{scope.row.cycle | getCycleTitle(cycleList)}}
        </template>
      </el-table-column>
      <el-table-column prop="play_times" label="播放次数" align="center"></el-table-column>
      <el-table-column label="创建时间" align="center" width="160px">
        <template slot-scope="scope">
          {{scope.row.create_time | dateTimeFormat}}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="390px">
        <template slot-scope="scope">
          <el-button v-if="showChange===true && scope.$index>0" type="info" size="mini" @click="changePos(scope.row.id, 1)">上移</el-button>
          <el-button v-if="showChange===true && scope.$index<practiceDayList.length-1" type="info" size="mini" @click="changePos(scope.row.id, 2)">下移</el-button>
          <el-button type="warning" icon="el-icon-copy-document" size="mini" @click="copyRow(scope.row.id)">复制</el-button>
          <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope.row.id)">编辑</el-button>
          <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteRow(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="param.page"
      :page-sizes="[10, 20, 30, 40, 50]"
      :page-size="param.count"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
    <practice-day-add :visible="addDialogAvaible"
      :id="currentId"
      :groupList="groupList"
      :speakerList="speakerList"
      :cycleList="cycleList"
      @add="add"
      @update="update"
      @close="closeAddDialog">
    </practice-day-add>
  </div>
</template>

<script>
import BreadCrumb from '../BreadCrumb.vue'
import PracticeDayAdd from './PracticeDayAdd.vue'
export default {
  name: 'carousel_list',
  components: {
    'bread-crumb': BreadCrumb,
    'practice-day-add': PracticeDayAdd
  },
  created () {
    this.getList()
    this.getGroupList()
    this.getSpeakerList()
  },
  data () {
    return {
      currentId: 0,
      practiceDayList: [],
      showChange: false,
      total: 0,
      pageTotal: 1,
      param: {
        group_id: 0,
        speaker_id: 0,
        category_id: 0,
        cycle: 0,
        day_time_start: 0,
        day_time_end: 0,
        page: 1,
        count: 10
      },
      cycleList: [
        { id: 10, title: '不循环' },
        { id: 100, title: '按年循环' }
      ],
      groupList: [],
      speakerList: [],
      categoryList: [],
      addDialogAvaible: false,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      dateValue: ''
    }
  },
  filters: {
    getCycleTitle (cycleId, cycleList) {
      for (var i = 0; i < cycleList.length; i++) {
        if (cycleList[i].id === cycleId) {
          return cycleList[i].title
        }
      }
      return '不循环'
    }
  },
  methods: {
    async getList () {
      const res = await this.$http.get('/admin/spiritual_practice_day/list', this.param)
      if (res.code === 0) {
        this.practiceDayList = res.data.list
        this.total = res.data.total
        this.pageTotal = res.data.total_page
      } else {
        this.$message.error(res.msg)
      }
    },
    async getGroupList () {
      const res = await this.$http.get('/admin/category/group/select_list')
      if (res.code === 0) {
        this.groupList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getSpeakerList () {
      const res = await this.$http.get('/admin/speaker/select_list')
      if (res.code === 0) {
        this.speakerList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    async getCategoryList () {
      if (this.param.group_id === 0 || this.param.speaker_id === 0) {
        this.categoryList = []
        this.param.category_id = 0
        return
      }
      const res = await this.$http.get('/admin/category/select_list', this.param)
      if (res.code === 0) {
        this.categoryList = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    timeChange () {
      this.showChange = false
      if (this.dateValue !== null) {
        this.param.day_time_start = this.dateValue[0] / 1000
        this.param.day_time_end = this.dateValue[1] / 1000 + 86399
        if (this.dateValue[0] === this.dateValue[1]) {
          this.showChange = true
        }
      } else {
        this.param.day_time_start = 0
        this.param.day_time_end = 0
      }
      this.getList()
    },
    handleSizeChange (size) {
      this.param.count = size
      this.getList()
    },
    handleCurrentChange (page) {
      this.param.page = page
      this.getList()
    },
    async add (data) {
      const res = await this.$http.post('/admin/spiritual_practice_day/add', data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async update (id, data) {
      const res = await this.$http.post('/admin/spiritual_practice_day/update/' + id, data)
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    async changePos (id, changeType) {
      const res = await this.$http.post('/admin/spiritual_practice_day/change_pos', {
        id: id,
        pos: changeType
      })
      if (res.code === 0) {
        this.closeAddDialog()
        this.getList()
      } else {
        this.$message.error(res.msg)
      }
    },
    showAddDialog () {
      this.addDialogAvaible = true
    },
    closeAddDialog () {
      this.addDialogAvaible = false
      this.currentId = 0
    },
    showEditDialog (id) {
      this.currentId = id
      this.showAddDialog()
    },
    deleteRow (id) {
      this.$confirm('是否真的要删除此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/spiritual_practice_day/delete/' + id)
        if (res.code === 0) {
          this.$message.success('删除成功')
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    },
    copyRow (id) {
      this.$confirm('是否真的要复制此记录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await this.$http.post('/admin/spiritual_practice_day/copy/' + id)
        if (res.code === 0) {
          this.$message.success('复制成功')
          this.getList()
        } else {
          this.$message.error(res.msg)
        }
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
</style>
